import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import RemoveIcon from "../../../../../assets/images/icons/x1.svg";
import { Modal } from "../../../../../components";
import { EndPoints } from "../../../../../Constants/endpoints";
import { useAppDispatch, useGetData } from "../../../../../hooks";
import { IStepFields } from "../../../../../interface/MedicalRecord";
import { decrementFileCount } from "../../../../../redux/reducers/investigationFilesSlice";
import MedicalFilePreview from "./MedicalFilePreview";
import ic_img from "../../../../../assets/images/icons/img.svg";
import { getFileTypeFromName, getFileTypeFromBase64 } from "./utils";


const UploadedFileCard = ({
  field,
  item,
  showRemove = true
}: {
  showRemove?: boolean;
  field: IStepFields;
  item: {
    // File?: File;
    Name?: string;
    Id?: number;
    ContentType?: string;
    isDeleted?: boolean;
  };
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState<boolean>(false);
  const [base64, setBase64] = useState<any>("");


  const useOptionalFormContext = () => {
    try {
      return useFormContext();
    } catch {
      return null;
    }
  };

  // usage
  const form = useOptionalFormContext();
  const watch = form?.watch;
  const setValue = form?.setValue;
  const dispatch = useAppDispatch();
  const { type } = useParams();



  const name = `Attributes.${String(field?.Id)}`
  const fileName = item?.Name ?? "";


  const optionsName = `${name}-option`;

  const uploadedInvestigationId =
    watch && watch(name);
  const uploadedInvestigationOptions =
    watch && watch(optionsName);



  const onCloseCard = (event: any) => {
    event.stopPropagation()
    dispatch(decrementFileCount(name));
    setValue && setValue(name, uploadedInvestigationId?.filter((id: any) => (item?.Id) != id));
    setValue && setValue(optionsName, uploadedInvestigationOptions?.filter((option: any) => (item?.Id) != option?.Id));

  };


  const { data, isLoading } = useGetData<{
    FileContent: string;
    ContentType: string;
  }>(
    `${showRemove || type === "Preview" ?
      EndPoints.GetFileTemp : EndPoints.GetMedicalRecordFile}/${item?.Id ?? uploadedInvestigationId}`,
    {
      enabled:
        isPreviewOpen &&
        (!!item?.Id || (!!uploadedInvestigationId)),
    },
  );
  const fileData = data?.Data;

 
  const determineFileType = (): "IMAGE" | "PDF" | undefined => {
   
    const contentType = item?.ContentType ?? fileData?.ContentType;


    if (contentType?.includes("image")) return "IMAGE";
    if (contentType?.includes("pdf")) return "PDF";

    if (contentType?.includes("octet-stream") || !contentType) {
   
      const fromName = getFileTypeFromName(item?.Name || fileName);
      if (fromName) return fromName;

   
      const fromBase64 = getFileTypeFromBase64(fileData?.FileContent);
      if (fromBase64) return fromBase64;
    }

    return "PDF";
  };

  const fileType = determineFileType();


  const filePreviewData: {
    fileAsBase64: string;
    fileType: "IMAGE" | "PDF" | undefined;
  } = {
        fileAsBase64: fileData?.FileContent as any,
        fileType: fileType,
      };

  const resolvedContentType =
    item?.ContentType ?? fileData?.ContentType ?? "";


  return (
    <div
      className={`flex cursor-pointer items-center justify-between rounded-lg border border-filter-outline p-4 shadow-sm ${showRemove ? "bg-primary-bg" : "bg-white"}`}
      onClick={() => setIsPreviewOpen(true)}
    >
      <div className="flex min-h-14 w-full items-center gap-4">
        <img
          src={ic_img}
          alt="File Icon"
          className={"h-8 w-8"}
        />
        <p className="line-clamp-1 truncate text-sm text-primary-text">
          {fileName}
        </p>
      </div>
      {showRemove && (
        <img
          src={RemoveIcon}
          className="flex h-6 w-6 cursor-pointer items-center justify-center"
          onClick={onCloseCard}
          alt="Remove"
        />
      )}

      {isPreviewOpen && (
        <Modal
          header={field?.Name}
          isOpen={isPreviewOpen}
          onClose={() => setIsPreviewOpen(false)}
          customStyle="lg:!max-w-[45vw] "
        >
          <MedicalFilePreview
            isLoading={isLoading}
            Name={fileName}
            type={filePreviewData?.fileType}
            file={filePreviewData?.fileAsBase64}
            contentType={resolvedContentType}
          />
        </Modal>
      )}
    </div>
  );
};

export default UploadedFileCard;
